import React from 'react';
import { useTranslation } from 'react-i18next';

import { NoteCaptureError } from './NoteCaptureRecording';
import NoteCaptureActionCard from './NoteCaptureActionCard';

export interface NoteCaptureErrorCardProps {
  error: NoteCaptureError;
  isAudioCapture: boolean;
  onDismiss: () => void;
  onRetry: () => void;
  retryLabel: string;
  inline?: boolean;
}

export default function NoteCaptureErrorCard({
  error,
  isAudioCapture,
  onDismiss,
  onRetry,
  retryLabel,
  inline = false,
}: NoteCaptureErrorCardProps): JSX.Element {
  const { t } = useTranslation('pageShiftNotes');

  const getTitle = () => {
    if (error.type === 'media') return t('noteCaptureRecording.error.media');
    if (isAudioCapture) return t('noteCaptureRecording.error.uploadAudio');
    return t('noteCaptureRecording.error.uploadText');
  };

  return (
    <NoteCaptureActionCard
      title={getTitle()}
      onClose={onDismiss}
      primaryLabel={retryLabel}
      onPrimaryClick={onRetry}
      inline={inline}
    />
  );
}
